import { cva, VariantProps } from 'class-variance-authority';
import { clamp } from 'es-toolkit';

const determinateProgressVariants = cva('relative rounded-bzc-circular bg-neutral-background-low overflow-hidden', {
  variants: {
    variant: {
      linear: ''
    },
    size: {
      medium: 'h-[10px]',
      small: 'h-[2px]'
    }
  },
  defaultVariants: {
    variant: 'linear',
    size: 'medium'
  }
});

interface DeterminateProgressProps extends VariantProps<typeof determinateProgressVariants> {
  value: number;
  className?: string;
}

export function DeterminateProgress({ className, value = 0, variant = 'linear', size = 'medium', ...props }: DeterminateProgressProps) {
  if (value < 0 || value > 100) {
    console.error('DeterminateProgress: value prop should be between 0 and 100');
    value = clamp(value, 0, 100);
  }

  return (
    <div
      role={'progressbar'}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={value}
      aria-label="Loading progress"
      className={determinateProgressVariants({ variant, size, className })}
      style={{
        // Fix overflow clipping in Safari
        // https://gist.github.com/domske/b66047671c780a238b51c51ffde8d3a0
        transform: 'translateZ(0)'
      }}
      {...props}
    >
      <div className="h-full rounded-bzc-circular bg-primary-foreground-main transition-all duration-700" style={{ width: `${value}%` }} />
    </div>
  );
}
